import React, { useEffect } from "react";
import styled from "styled-components";
import Portal from "./Portal";
import { loading_bg } from "styles/img";

function Loader({ message, isFixed = true }) {
  useEffect(() => {
    if (isFixed) {
      document.body.style.cssText = `position: fixed; top: -${window.scrollY}px; width:100%;`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = `position: ""; top: ""; width: "";`;
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      };
    }
  }, []);

  return (
    <Portal elementId="modal-root">
      <LoaderOverlay />
      <LoaderWrapper tabIndex={-1}>
        <div className="apply_form" style={{ display: "block" }} tabIndex={0}>
          <div className="loading_wrap">
            <img src={loading_bg} className="loading" alt="로딩 이미지" />
          </div>
        </div>
        {/* <LoaderInner tabIndex={0} /> */}
      </LoaderWrapper>
    </Portal>
  );
}

const LoaderWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  overflow: auto;
  outline: 0;
`;

const LoaderOverlay = styled.div`
  box-sizing: border-box;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1999;
`;

// const LoaderInner = styled.div`
//   margin: auto;
//   font-size: 10px;
//   position: relative;
//   text-indent: -9999em;
//   border: 1.1em solid rgba(255, 255, 255, 0.2);
//   border-left: 1.1em solid #ffffff;
//   -webkit-transform: translateZ(0);
//   -ms-transform: translateZ(0);
//   transform: translateZ(0);
//   -webkit-animation: load8 1.1s infinite linear;
//   animation: load8 1.1s infinite linear;
//   border-radius: 50%;
//   width: 5em;
//   height: 5em;

//   @-webkit-keyframes load8 {
//     0% {
//       -webkit-transform: rotate(0deg);
//       transform: rotate(0deg);
//     }
//     100% {
//       -webkit-transform: rotate(360deg);
//       transform: rotate(360deg);
//     }
//   }
//   @keyframes load8 {
//     0% {
//       -webkit-transform: rotate(0deg);
//       transform: rotate(0deg);
//     }
//     100% {
//       -webkit-transform: rotate(360deg);
//       transform: rotate(360deg);
//     }
//   }
// `;

export default Loader;
